import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';

import { PlatformApiService, ResultFilter, Results } from '../../services/platform-api.service';
import { Brand } from '../../models/AccountModel';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'cw-ci-admin-brand-list',
  templateUrl: './brand-list.component.html',
  styleUrls: ['./brand-list.component.scss']
})
export class BrandListComponent implements OnInit {

  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(DataTableComponent, { static: true }) brandDataTable: DataTableComponent;
  brandList: Results;

  constructor(private _platformApi: PlatformApiService, public dialog: MatDialog) { }

  ngOnInit() {

  }

  isSelectable(item: Brand) {
    return true;
  }

  editBrand(item: Brand) {
    this.stateChange.emit({ state: 'EDIT', item });
  }

  loadBrands(filter = new ResultFilter()) {
    this.brandDataTable.showProcessing();
    const listObservable = this._platformApi.getBrands(filter);
    listObservable.subscribe(results => {
      this.brandList = results;
    })
  }

}
